import { createContext, useContext } from "react";

export const HotelAlertContext = createContext(null);

export const useHotelAlerts = () => {
  const context = useContext(HotelAlertContext);

  if (!context) {
    throw new Error("useHotelAlerts must be used inside HotelAlertProvider.");
  }

  return context;
};
